// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"07de3e7d","239":"ab7acf49","370":"80238a09","667":"002b60fc"}[chunkId] + ".chunk.js";
};